
import { authApiV2 } from '../axiosWrapper';
import {  ISeascapeActivityLog } from './activityLogTypes';
import { 
    trackExceptionWithContext
} from '../services/application-insights/appInsights';
import { 
    AppInsightsActions, 
    AppInsightsComponents, 
    AppInsightsErrorTypes 
} from '../services/application-insights/appInsightsConstants';

export const addSeascapeLogActivity = async (activityLog: ISeascapeActivityLog) => {
     const endpoint = '/seascapeactivitylogs/add-log';
     
     try {
          await authApiV2.post(endpoint, {
               eventId: activityLog.eventId,
               payload:  activityLog.payload,
          });
     } catch (error) {
          // Only log exceptions to Application Insights
          trackExceptionWithContext(
               error instanceof Error ? error : new Error(String(error)),
               {
                    component: AppInsightsComponents.ACTIVITY_LOG_API,
                    action: AppInsightsActions.API_REQUEST,
                    additionalData: {
                         errorType: AppInsightsErrorTypes.API_ERROR,
                         endpoint: endpoint,
                         eventId: activityLog.eventId,
                         hasPayload: !!activityLog.payload
                    }
               }
          );
          
          // Re-throw the error to maintain existing behavior
          throw error;
     }
};


